import { Prescription } from '../schema'

const getStrength = ({ sph, cyl }: { sph: number; cyl: number }) => {
  if (sph === 0) return cyl
  if (cyl === 0) return sph

  if (Math.sign(sph) === Math.sign(cyl)) {
    return sph + cyl
  }
  // If only one is negative, return the one with the larger absolute value, preserving its sign
  return Math.abs(sph) >= Math.abs(cyl) ? sph : cyl
}

const getAbsoluteStrength = (prescription: Prescription) => {
  const strL = RefractionUtils.getStrength({
    sph: prescription.l_sph,
    cyl: prescription.l_cyl,
  })
  const strR = RefractionUtils.getStrength({
    sph: prescription.r_sph,
    cyl: prescription.r_cyl,
  })

  const str = Math.max(strL, strR)

  return Math.abs(str)
}

const normalizePdValue = (value: number | string | undefined | null) => {
  if (value === '' || value === undefined) return null
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export type PdValues = {
  r_pd?: number | string | null
  l_pd?: number | string | null
}

const isPdSame = (left?: PdValues | null, right?: PdValues | null) => {
  if (!left && !right) return true
  if (!left || !right) return false
  return (
    normalizePdValue(left.l_pd) === normalizePdValue(right.l_pd) &&
    normalizePdValue(left.r_pd) === normalizePdValue(right.r_pd)
  )
}

export const RefractionUtils = {
  getStrength,
  getAbsoluteStrength,
  pd: {
    isSame: isPdSame,
    normalize: normalizePdValue,
  },
}
